import { Controller } from "@hotwired/stimulus"
import Cropper from "cropperjs"

export default class extends Controller {
  static targets = ["modal", "image", "loading", "cropperContainer"]
  static values = {
    aspectRatio: { type: Number, default: 3 },
    maxWidth: { type: Number, default: 1200 },
    maxHeight: { type: Number, default: 400 }
  }

  connect() {
    this.cropper = null
    this.resolveCallback = null
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    this.destroyCropper()
    document.removeEventListener("keydown", this.handleKeydown)
  }

  open(file) {
    return new Promise((resolve) => {
      this.resolveCallback = resolve
      this.showModal()
      this.showLoading()

      const reader = new FileReader()
      reader.onload = (e) => {
        this.imageTarget.src = e.target.result
        this.imageTarget.onload = () => {
          this.hideLoading()
          this.initCropper()
        }
      }
      reader.readAsDataURL(file)
    })
  }

  initCropper() {
    this.destroyCropper()

    this.cropper = new Cropper(this.imageTarget, {
      aspectRatio: this.aspectRatioValue,
      viewMode: 1,
      dragMode: "crop",
      cropBoxResizable: true,
      cropBoxMovable: true,
      toggleDragModeOnDblclick: true,
      minContainerHeight: 350,
      zoomOnWheel: true,
      wheelZoomRatio: 0.1
    })
  }

  crop() {
    if (!this.cropper) return

    const canvas = this.cropper.getCroppedCanvas({
      width: this.maxWidthValue,
      height: this.maxHeightValue,
      imageSmoothingQuality: "high"
    })

    canvas.toBlob((blob) => {
      if (this.resolveCallback) {
        this.resolveCallback(blob)
        this.resolveCallback = null
      }
      this.hideModal()
      this.destroyCropper()
    }, "image/jpeg", 0.92)
  }

  cancel() {
    if (this.resolveCallback) {
      this.resolveCallback(null)
      this.resolveCallback = null
    }
    this.hideModal()
    this.destroyCropper()
  }

  closeBackground(event) {
    if (event.target === this.modalTarget) {
      this.cancel()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.cancel()
    }
  }

  showModal() {
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this.handleKeydown)
  }

  hideModal() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.handleKeydown)
  }

  showLoading() {
    if (this.hasLoadingTarget) this.loadingTarget.classList.remove("hidden")
    if (this.hasCropperContainerTarget) this.cropperContainerTarget.classList.add("hidden")
  }

  hideLoading() {
    if (this.hasLoadingTarget) this.loadingTarget.classList.add("hidden")
    if (this.hasCropperContainerTarget) this.cropperContainerTarget.classList.remove("hidden")
  }

  destroyCropper() {
    if (this.cropper) {
      this.cropper.destroy()
      this.cropper = null
    }
  }
}
